// import React, { useState } from "react";
// import Swal from "sweetalert2";

// const DOCS = [
//     { id: "aadhaar", label: "Aadhaar Card", img: "https://images.moneycontrol.com/static-mcnews/2025/04/20250404112835_Aadhaar-card-generated-using-AI.png" },
//     { id: "pan", label: "PAN Card", img: "https://akm-img-a-in.tosshub.com/indiatoday/images/story/202508/under-the-pan-20-project--the-updated-card-will-have-added-features--including-qr-code-for-enhanced-050330686-16x9.jpg?VersionId=u.H84zioJnV0C57IlNfdLpSoZM_HRZwX&size=690:388" },
// ];

// export default function DocumentApproval({user_id}) {
//     const [status, setStatus] = useState({ aadhaar: "pending", pan: "pending" });
//     const [lightbox, setLightbox] = useState(null);

//     const act = (id, action) => {
//         Swal.fire({
//             icon: "warning",
//             title: "Are you sure ?",
//             text: `You want to ${action === 'rejected' ? "Reject" : "Approve"} document.`,
//             showCancelButton: true,
//         }).then(async willOkay => {
//             if (willOkay.isConfirmed) {
//                 setStatus(p => ({ ...p, [id]: action }))
//             }
//         })
//     };

//     const pillStyle = (s) => ({
//         pending: { background: "#fef9c3", color: "#854d0e" },
//         approved: { background: "#dcfce7", color: "#166534" },
//         rejected: { background: "#fee2e2", color: "#991b1b" },
//     }[s]);

//     return (
//         <div className="border rounded p-4 shadow shadow-sm" style={{ maxWidth: 480, margin: "0px" }}>

//             <p style={{ fontSize: 16, fontWeight: 600, color: "#111", marginBottom: 16 }}>Documents For Approval</p>

//             {DOCS.map((doc, i) => (
//                 <div key={doc.id} style={{
//                     display: "flex", alignItems: "center", gap: 12,
//                     padding: "12px 0",
//                     borderTop: i === 0 ? "1px solid #e5e7eb" : undefined,
//                     borderBottom: "1px solid #e5e7eb",
//                 }}>

//                     {/* Thumbnail */}
//                     <img
//                         src={doc.img}
//                         alt={doc.label}
//                         onClick={() => setLightbox(doc.id)}
//                         style={{ width: 48, height: 36, objectFit: "cover", borderRadius: 6, cursor: "zoom-in", flexShrink: 0 }}
//                     />

//                     {/* Label */}
//                     <span style={{ flex: 1, fontSize: 14, fontWeight: 500, color: "#111" }}>{doc.label}</span>

//                     {/* Status pill */}
//                     <span style={{
//                         fontSize: 11, fontWeight: 600, padding: "2px 9px",
//                         borderRadius: 20, textTransform: "capitalize",
//                         ...pillStyle(status[doc.id])
//                     }}>
//                         {status[doc.id]}
//                     </span>

//                     {/* Buttons */}
//                     <button
//                         type="button"
//                         onClick={() => act(doc.id, "rejected")}
//                         disabled={status[doc.id] !== "pending"}
//                         style={{
//                             padding: "5px 12px", borderRadius: 7, border: "1px solid #fca5a5",
//                             background: "#fff", color: "#ef4444", fontSize: 12, fontWeight: 600,
//                             cursor: "pointer", opacity: status[doc.id] !== "pending" ? 0.35 : 1
//                         }}
//                     >Reject</button>

//                     <button
//                         type="button"
//                         onClick={() => act(doc.id, "approved")}
//                         disabled={status[doc.id] !== "pending"}
//                         style={{
//                             padding: "5px 12px", borderRadius: 7, border: "none",
//                             background: "#16a34a", color: "#fff", fontSize: 12, fontWeight: 600,
//                             cursor: "pointer", opacity: status[doc.id] !== "pending" ? 0.35 : 1
//                         }}
//                     >Approve</button>

//                 </div>
//             ))}

//             {/* Lightbox */}
//             {lightbox && (
//                 <div
//                     onClick={() => setLightbox(null)}
//                     style={{
//                         position: "fixed", inset: 0, background: "rgba(0,0,0,0.85)",
//                         display: "flex", alignItems: "center", justifyContent: "center",
//                         zIndex: 9999, cursor: "zoom-out", padding: 24,
//                     }}
//                 >
//                     <img
//                         src={DOCS.find(d => d.id === lightbox).img}
//                         onClick={e => e.stopPropagation()}
//                         style={{ maxWidth: "90vw", maxHeight: "88vh", borderRadius: 10 }}
//                     />
//                 </div>
//             )}
//         </div>
//     );
// }

import React, { useEffect, useState } from "react"
import { Spinner } from "reactstrap"
import Swal from "sweetalert2"
import { fetchNodeData, FetchNodePostData } from "utils/common-fetchData"
import { axiosNodeInstance } from "utils/config"

export default function DocumentApproval({ user_id, fetchDocuments }) {
  const [docs, setDocs] = useState([])
  const [status, setStatus] = useState({})
  const [loading, setLoading] = useState(false)
  const [reUploadFiles, setReUploadFiles] = useState({})

  const token = localStorage.getItem("auth_token") // adjust if different
  console.log(reUploadFiles)
  // =========================
  // FETCH DOCUMENTS
  // =========================
  const getDocuments = async () => {
    const res = await fetchNodeData(
      false,
      `employeeJoining/getDocuments/${user_id}`,
      token
    )

    if (res?.success) {
      setDocs(res.files || [])

      // map status
      const statusMap = {}
      res.files.forEach(f => {
        statusMap[f.id] =
          f.status === 1 ? "approved" : f.status === 2 ? "rejected" : "pending"
      })
      setStatus(statusMap)
    }
  }

  useEffect(() => {
    if (user_id) getDocuments()
  }, [user_id])

  // =========================
  // APPROVE / REJECT
  // =========================
  const act = (doc, action) => {
    Swal.fire({
      icon: "warning",
      title: "Are you sure ?",
      text: `You want to ${action === "rejected" ? "Reject" : "Approve"
        } document.`,
      showCancelButton: true,
    }).then(async res => {
      if (res.isConfirmed) {
        const payload = {
          id: doc.id,
          status: action === "approved" ? 1 : 2,
          user_id: localStorage.getItem("auth_id")
        }

        const apiRes = await FetchNodePostData(
          false,
          "employeeJoining/documentApproval",
          token,
          payload
        )

        if (apiRes?.data?.success) {
          setStatus(p => ({
            ...p,
            [doc.id]: action,
          }))

          Swal.fire("Success", apiRes.data.message, "success").then(() => {
            getDocuments()
            fetchDocuments()
          })
        }
      }
    })
  }

  async function reUpload(docId) {
    if (!reUploadFiles[docId]) return swal("", "Please select file.", "warning")
    Swal.fire({
      icon: "warning",
      title: "Are you sure ?",
      text: `You want to upload file.`,
      showCancelButton: true,
    }).then(async willOkay => {
      if (willOkay.isConfirmed) {
        try {
          setLoading(docId)
          const payload = new FormData()
          payload.append("file_id", docId)
          payload.append("user_id", localStorage.getItem("auth_id"))
          payload.append("file", reUploadFiles[docId])

          const apiRes = await axiosNodeInstance.post(
            "employeeJoining/reuploadDocument",
            payload,
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
              },
            }
          )

          if (apiRes?.data?.success) {
            setLoading(false)
            Swal.fire("Success", apiRes.data.message, "success").then(() => {
              getDocuments()
              fetchDocuments()

              const files = { ...reUploadFiles }
              delete files[docId]
              setReUploadFiles(files)
            })
          }
        } catch (error) {
          console.log(error)
          swal(
            "Oops!",
            error?.response?.data?.message || error.message,
            "Something went wrong.",
            "error"
          )
        }
      }
    })
  }

  const pillStyle = s =>
  ({
    pending: { background: "#fef9c3", color: "#854d0e" },
    approved: { background: "#dcfce7", color: "#166534" },
    rejected: { background: "#fee2e2", color: "#991b1b" },
  }[s])

  return (
    <>
      <div
        className="border rounded p-3 shadow shadow-sm"
        style={{ margin: "0px" }}
      >
        <h5 className="text-dark mb-3">Documents For Approval</h5>

        {docs.map((doc, i) => (
          <div
            key={doc.id}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 12,
              padding: "12px 0",
              borderTop: i === 0 ? "1px solid #e5e7eb" : undefined,
              borderBottom: "1px solid #e5e7eb",
            }}
          >
            <div className="d-flex align-items-center gap-2">
              <div>
                <a
                  href={doc.link}
                  target="_black"
                  className="d-block fs-5 p-2 py-1 border rounded bg-light"
                >
                  <i className="fa fa-eye"></i>
                </a>
              </div>

              {/* Label */}
              <div>
                <span
                  style={{
                    flex: 1,
                    fontSize: 14,
                    fontWeight: 500,
                    color: "#111",
                  }}
                >
                  {doc.file_name}
                </span>
                <div style={{ fontSize: "10px" }}>{doc.original_filename}</div>
              </div>
            </div>

            <div className="d-flex align-items-center gap-2">
              {/* Status */}
              <span
                style={{
                  fontSize: 11,
                  fontWeight: 600,
                  padding: "2px 9px",
                  borderRadius: 20,
                  textTransform: "capitalize",
                  ...pillStyle(status[doc.id]),
                }}
              >
                {status[doc.id]}
              </span>
              {doc.status == 2 ? (
                <div className="d-flex gap-2">
                  <input
                    type="file"
                    className="form-control"
                    style={{ fontSize: "10px", width: "180px" }}
                    title="Re-upload document"
                    onChange={e => {
                      setReUploadFiles(prev => ({
                        ...prev,
                        [doc.id]: e.target.files[0],
                      }))
                    }}
                  />
                  <button
                    type="button"
                    disabled={doc.id === loading}
                    onClick={() => reUpload(doc.id)}
                    className="btn btn-sm btn-purple"
                  >
                    {doc.id === loading ? (
                      <Spinner size="sm" />
                    ) : (
                      <i className="fa fa-upload"></i>
                    )}
                  </button>
                </div>
              ) : (
                <>
                  {/* Reject */}
                  <button
                    type="button"
                    onClick={() => act(doc, "rejected")}
                    disabled={status[doc.id] !== "pending"}
                    style={{
                      padding: "4px 12px",
                      borderRadius: 7,
                      border: "1px solid #fca5a5",
                      background: "#fff",
                      color: "#ef4444",
                      fontSize: 12,
                      fontWeight: 600,
                      cursor: "pointer",
                      opacity: status[doc.id] !== "pending" ? 0.35 : 1,
                    }}
                  >
                    Reject
                  </button>

                  {/* Approve */}
                  <button
                    type="button"
                    onClick={() => act(doc, "approved")}
                    disabled={status[doc.id] !== "pending"}
                    style={{
                      padding: "5px 12px",
                      borderRadius: 7,
                      border: "none",
                      background: "#16a34a",
                      color: "#fff",
                      fontSize: 12,
                      fontWeight: 600,
                      cursor: "pointer",
                      opacity: status[doc.id] !== "pending" ? 0.35 : 1,
                    }}
                  >
                    Approve
                  </button>
                </>
              )}
            </div>
          </div>
        ))}

        {!docs.length && <span>No document Available</span>}
      </div>
    </>
  )
}
